import React from 'react'

const IconHeartLinear = ({ className }: { className: string }): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <path
        d="M50.0561 9.44344C44.4649 3.85219 35.399 3.85219 29.8069 9.44344C29.1183 10.1321 28.5189 10.8749 27.9991 11.6563C27.4803 10.8758 26.88 10.1321 26.1914 9.44344C20.6001 3.85219 11.5343 3.85219 5.94214 9.44344C0.350016 15.0347 0.350016 24.1006 5.94214 29.6927L28 51.7488L50.0561 29.6927C55.6483 24.1006 55.6483 15.0347 50.0561 9.44344Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default IconHeartLinear
